import React from 'react';

const NotFound = () => {
    return (
        <div className='flex h-screen justify-center items-center'>
            <img src="https://colorlib.com/cdn-cgi/image/quality=80,format=auto,onerror=redirect,metadata=none/wp/wp-content/uploads/sites/2/404-error-page-templates.jpg" alt="" />
        </div>
    );
};

export default NotFound;